/**
 * CD / Half-CD "debt-paying plan" garnish keys.
 *
 * A Half-CD slot's cash earnings garnish into its open debt only for the plans
 * the tenant lists in `tenant_config.features.half_cd_debt_plans`. Inclusion is
 * normally keyed on the source PLAN code — but a few ledger KINDS live under a
 * shared source plan yet warrant their own independent toggle. The Binary
 * Mentor's Bonus (`kind='binary_mentor_bonus'`, `source_plan='binary'`) is the
 * first: without this, it could only be garnished as part of "Binary" (its
 * pairing) rather than on its own.
 *
 * `garnishKeyForKind` maps a credit to the key its garnish is governed by; the
 * garnish loop sums only the credits whose key is in `half_cd_debt_plans` (for a
 * Half-CD slot) into the single aggregated `cd_debt_payment` debit per plan.
 * `GARNISH_EXTRA_KINDS` are the extra (non-plan-code) entries the admin debt
 * checklist renders alongside `SUPPORTED_PLAN_CODES`.
 */

/** Ledger kinds whose debt garnish is toggled independently of their source plan. */
const KIND_TO_GARNISH_KEY: Record<string, string> = {
  binary_mentor_bonus: 'binary_mentor_bonus',
};

/**
 * The garnish key governing whether a given credit pays down a Half-CD debt.
 * Special-cased kinds use their own key; everything else uses the plan code.
 */
export function garnishKeyForKind(kind: string, planCode: string): string {
  return KIND_TO_GARNISH_KEY[kind] ?? planCode;
}

/** Extra garnishable entries (beyond the plan codes) for the debt-plan checklist. */
export const GARNISH_EXTRA_KINDS = [
  { key: 'binary_mentor_bonus', label: 'Binary Mentor Bonus' },
] as const;
